import { FormControl } from '@angular/forms';
import {
  MCGRSettlementScopeFormGroup,
  SettlementScope,
  SettlementScopeDto,
} from '../costs-section/costs-section-form.model';

export enum MCGRNewRequestFinancialSectorApplicationControlName {
  Unit = 'unit',
}

export interface MCGRFinancialSectorApplicationFormGroup
  extends MCGRSettlementScopeFormGroup {
  [MCGRNewRequestFinancialSectorApplicationControlName.Unit]: FormControl<string>;
}

export interface FinancialSectorApplication extends SettlementScope {
  [MCGRNewRequestFinancialSectorApplicationControlName.Unit]: string;
}

export class FinancialSectorApplicationDto extends SettlementScopeDto {
  constructor(
    public Jednostka: string,
    ZakresRzeczowy: string,
    Kwota?: number,
    UdzialProcent?: number,
  ) {
    super(ZakresRzeczowy, Kwota, UdzialProcent);
  }

  static override fromAppToApi(
    data: FinancialSectorApplication,
  ): FinancialSectorApplicationDto {
    return new this(data.unit, data.scope, data.amount, data.percentageShare);
  }
}
